import { DATA_KEYS, useRemoteData } from "@/utils/useRemoteData";
import { useSpotUser } from "@/utils/spotUser";
import { providerCurrency } from "@/utils/billingCurrency";

export function useBillingCurrency() {
  const { spotTenant } = useSpotUser();
  const { data } = useRemoteData(DATA_KEYS.BILLING_CURRENCY, undefined, {
    queryKey: [DATA_KEYS.BILLING_CURRENCY, spotTenant.id],
    enabled: !!spotTenant.id,
    staleTime: 60_000,
    retry: false,
  });
  return providerCurrency(data);
}
